<div class="progress-loader" [hidden]="!(loaderService.isLoading | async)">
    <div id="loader-item">
        <mat-progress-spinner [mode]="'indeterminate'" diameter=50>
        </mat-progress-spinner>
    </div>
</div>

<!-- <div [hidden]="!(loaderService.isLoading | async)">
    <h1>CARGANDOOOOOOO.........</h1>
</div> -->